// extracted by mini-css-extract-plugin
export default {"menuBlock":"WH-z","title":"XH-z","nav":"YH-z","flexCell":"ZH-z","facetLink":"_H-z"};